import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Icon, Button, Caption } from '../../cdl-react-components/components'
import { setConfiguration } from '../../../store/actions'
import { getCookie, setCookie } from '../../cdl-react-components/utilities'

const Controls = ({ cookieName }) => {
    const dispatch = useDispatch()
    const { sidebarShown, subSidebarShown  } = useSelector(_ => _.data.configuration)
    const [showTooltip, setShowTooltip] = useState()

    useEffect(() => {
        setShowTooltip(!getCookie(cookieName))
    }, [cookieName])

    const toggleSubSidebar = () => dispatch(setConfiguration({ subSidebarShown: !subSidebarShown }))
    const toggleSidebar = () => {
        if (showTooltip) {
            setShowTooltip(false)
            setCookie(cookieName, true)
        }
        dispatch(setConfiguration({ sidebarShown: !sidebarShown }))
    }

    const renderIcon = (icon, open, callback) => (
        <Button 
            className={'controls__icon' + (open ? ' controls__icon--open' : '')} 
            onClick={callback}>
            <Icon>{icon}</Icon>
        </Button>
    )

    return (
        <div id="controls" className="hide-phone">
            {renderIcon('search', sidebarShown, toggleSidebar)}
            {renderIcon('menu', subSidebarShown, toggleSubSidebar)}
            {showTooltip && (
                <div className="controls__tooltip">
                    <Caption>Search&nbsp;for&nbsp;Content</Caption>
                </div>
            )}
        </div>
    )
}

export default Controls
